import { NavLink, Outlet, Navigate } from 'react-router-dom';
import { AdminFiltersProvider } from '../../contexts/AdminFiltersContext';
import StatsFilters from '../../components/admin/StatsFilters';
import { isAdmin } from '../../utils/auth';

const NAV = [
  { to: '/admin', label: 'Overview', end: true },
  { to: '/admin/messages', label: 'Messages' },
  { to: '/admin/conversations', label: 'Conversations' },
  { to: '/admin/agents', label: 'Agents' },
  { to: '/admin/response-times', label: 'Response times' },
  { to: '/admin/templates', label: 'Templates' },
  { to: '/admin/audit', label: 'Audit' },
  { to: '/admin/funnel', label: 'Funnel IT' },
  { to: '/admin/alerts', label: 'Alerts' },
  { to: '/admin/blocked', label: 'Blocked' },
  { to: '/admin/api-keys', label: 'API Keys' },
  { to: '/admin/users', label: 'Users' },
];

export default function AdminLayout() {
  if (!isAdmin()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AdminFiltersProvider>
      <div className="flex h-full w-full">
        <aside className="w-52 bg-gray-50 border-r border-gray-200 flex-shrink-0 overflow-y-auto">
          <div className="px-4 py-3 text-sm font-semibold text-gray-700 border-b border-gray-200">
            📊 Admin panel
          </div>
          <nav className="flex flex-col py-2">
            {NAV.map(({ to, label, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 border-l-2 border-blue-600 font-medium'
                      : 'text-gray-700 hover:bg-gray-100'
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="flex-1 flex flex-col overflow-hidden">
          <StatsFilters />
          <div className="flex-1 overflow-y-auto p-4 bg-gray-50">
            <Outlet />
          </div>
        </main>
      </div>
    </AdminFiltersProvider>
  );
}
